import { render, staticRenderFns } from "./AICall.vue?vue&type=template&id=f3d68a4a"
import script from "./AICall.vue?vue&type=script&lang=js"
export * from "./AICall.vue?vue&type=script&lang=js"
import style0 from "./AICall.vue?vue&type=style&index=0&id=f3d68a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports